import React, {useMemo} from 'react';
import clsx from 'clsx';
import {useResizeWindow} from '@hooks/useResizeWindow';
import {useCanManageTariff} from '@hooks/useCanManageTariff';
import {Dropdown} from '../Dropdown';
import styles from './Navigation.module.scss';
import {headerNavLinks} from './config';
import {CustomLink} from './CustomLink';

const LAPTOP_BP = 1256;

export const Navigation = () => {
    const width = useResizeWindow();
    const isLaptopDown = width < LAPTOP_BP;
    const {canManageTariff: showTariffsLink} = useCanManageTariff();

    const navLinks = useMemo(
        () => headerNavLinks.filter(link => link.path !== '/tariffs' || showTariffsLink),
        [showTariffsLink],
    );

    if (isLaptopDown) {
        return (
            <div className={styles.navigation}>
                <Dropdown
                    label="Каталог"
                    items={navLinks.map(i => (
                        <div key={i.path} className={styles.navigation__item}>
                            <CustomLink path={i.path}>{i.label}</CustomLink>
                        </div>
                    ))}
                    buttonClassName={styles.navigation__item}
                />
            </div>
        );
    }

    return (
        <div className={clsx('d-none d-bp768-flex', styles.navigation)}>
            {navLinks.map(i => (
                <CustomLink key={i.path} path={i.path} shortLabel={i.shortLabel}>{i.label}</CustomLink>
            ))}
        </div>
    );
};

